import { useUserStore } from '@/store';

import { type BoundaryProps, ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryDashboard = (props: BoundaryProps) => (
  <ErrorBoundary
    {...props}
    errorMessage="Error loading dashboard"
    redirectTo="/login"
    onRetry={() => {
      useUserStore.getState().logout();
    }}
  />
);
